"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncReportStatusToJSON = exports.AsyncReportStatusFromJSONTyped = exports.AsyncReportStatusFromJSON = exports.AsyncReportStatus = void 0;
/**
 * The status that represents the state of the report.
 *
 * @export
 */
exports.AsyncReportStatus = {
    Processing: 'PROCESSING',
    Ready: 'READY',
    Expired: 'EXPIRED',
    Failed: 'FAILED'
};
function AsyncReportStatusFromJSON(json) {
    return AsyncReportStatusFromJSONTyped(json, false);
}
exports.AsyncReportStatusFromJSON = AsyncReportStatusFromJSON;
function AsyncReportStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AsyncReportStatusFromJSONTyped = AsyncReportStatusFromJSONTyped;
function AsyncReportStatusToJSON(value) {
    return value;
}
exports.AsyncReportStatusToJSON = AsyncReportStatusToJSON;
